// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".other-office-message-reply[data-v-0c57326e]  .register-group{margin:0!important}.other-office-message-reply[data-v-0c57326e]  .register-row{margin-bottom:.5rem}.other-office-message-reply .reply-btn[data-v-0c57326e]{width:60px;height:32px!important;font-size:14px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
